import { gsap } from 'gsap';

import { contactMap } from '../lib/contactMap';

export async function initBlockContactsMap(parent) {
  if (!parent) return;

  const cards = parent.querySelectorAll('.block-contacts-map__item');
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: parent,
      start: 'top 75%',
      toggleActions: 'play none none none',
      once: true,
      // markers: true,
    },
  });
  tl.fromTo(
    cards,
    { autoAlpha: 0, y: 20 },
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.8,
      ease: 'power2.out',
      stagger: 0.15,
    },
  );

  const mapElement = parent.querySelector('.block-contacts-map__map');

  const iframe = mapElement.querySelector('iframe');

  if (iframe) {
    return;
  }

  contactMap(mapElement);
}

export function initAllBlockContactsMaps(selector = '.js-block-contacts-map') {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initBlockContactsMap(block));
}
